import Vue from 'vue';
import Icon from 'vue-awesome/components/Icon';

Vue.component('icon', Icon);

export default Icon;



// WEBPACK FOOTER //
// ./node_modules/@triotech/vue-core/src/vendor/font-awesome.js